import React, { Component } from "react"
import PropTypes from "prop-types"

const FeatureContext = React.createContext([])

const propTypes = {
  children: PropTypes.any,
  name: PropTypes.string.isRequired
}

const Enabled = ({ children, name }) => (
  <FeatureContext.Consumer>
    {features => (features.includes(name) ? children : null)}
  </FeatureContext.Consumer>
)
Enabled.propTypes = propTypes

const Disabled = ({ children, name }) => (
  <FeatureContext.Consumer>
    {features => (features.includes(name) ? null : children)}
  </FeatureContext.Consumer>
)
Disabled.propTypes = propTypes

export const Feature = { Enabled, Disabled }

export class Features extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  constructor(props) {
    super(props)
    this.state = {
      features: []
    }
  }

  componentDidMount() {
    const meta = document.head.querySelector("[name=convertkit_features]")
    const features = meta && meta.content
    if (features) {
      this.setState({ features: features.split(",") })
    }
  }

  render() {
    return (
      <FeatureContext.Provider value={this.state.features}>
        {this.props.children}
      </FeatureContext.Provider>
    )
  }
}
